<template>
  <div style="margin-top:30px">
    <el-form ref="form" :rules="rules" :model="form" label-width="80px">
      <el-row>
        <el-form-item label="客户" prop="shipmentCode">
          <shipmentSelect ref="shipmentSelect" style="width: 100%" @setCustomerCode="setCustomerCode" />
        </el-form-item>
        <el-form-item label="备注" prop="remarks" style="margin-right:15px">
          <el-input v-model="form.remarks" placeholder="请输入备注" />
        </el-form-item>
        <el-form-item label="合同名称" prop="name" style="margin-right:15px">
          <el-input v-model="form.name" placeholder="请输入合同名称" />
        </el-form-item>
        <el-form-item label="附件地址" prop="contractPath">
          <el-upload
            ref="upload"
            :headers="headers"
            class="upload-demo"
            :action="uploadUrl"
            :auto-upload="true"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeUploadFile"
            :file-list="fileList"
          >
            <el-button slot="trigger" size="small" type="primary">
              选取文件
            </el-button>
            <div slot="tip" class="el-upload__tip">
              只能上传1个文件，且不超过10M
            </div>
          </el-upload>
          <el-input v-model="form.fileName" type="hidden" />
          <el-input v-model="form.contractPath" type="hidden" />
        </el-form-item>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="funcCancel">
        取 消
      </el-button>
      <el-button type="primary" @click="funcSubmit">
        确 定
      </el-button>
    </div>
  </div>
</template>
<script>
import request from "@/utils/request";
import { getToken } from '@/utils/auth';
export default {
  name: "ContractAdd",
  data() {
    return {
      uploadUrl: this.BASE_API_URL + "ntocc-tps-api/fileUpload",
      headers: {
        Authorization: "Bearer " + getToken(),
        deviceId: "0000000000",
      },
      form: {
        code: "",
        shipmentCode: "",
        name: "",
        contractPath: "",
      },
      partys: [],
      rules: {
        code: [
          { required: true, message: "请输入预约入库单号", trigger: "blur" },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: "blur",
          },
        ],
        shipmentCode: [
          { required: true, message: "请输入客户", trigger: "blur" },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: "blur",
          },
        ],
        name: [
          { required: true, message: "请输入合同名称", trigger: "blur" },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: "blur",
          },
        ],
        contractPath: [
          { required: true, message: "请上传正确的附件", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.findShipmentPartys();
  },
  methods: {
    findShipmentPartys() {
      request({
        url: "/ntocc-basic-api/party/wmsShipment",
        method: "get",
        params: { name: this.partyName },
      }).then((response) => {
        this.partys = response.data;
      });
    },
    //上传前校验
    beforeUploadFile(file) {
      let size = file.size / 1024 / 1024
      if(size > 10) {
        this.$message.error('上传文件大小不能超过 10MB!')
        return false
      }
      // 获取token值，实时获取
      this.headers.Authorization = 'Bearer ' + getToken()
      return true
    },
    handleAvatarSuccess(response, file, fileList) {
      if(response.status==500){
        this.$message.error(response.msg)
      } else {
        this.$message({ message: response.msg, type: "success" });
        this.form.contractPath = response.data;
        this.form.fileName = file.name;
      }
    },
    // 文件上传失败时的钩子
    handleError(err, file, fileList) {
      this.$notify.error({
        title: "错误",
        message: `文件上传失败`,
      });
    },

    uploadFile: function (file) {
      this.fileData.append("file", file.file);
    },
    // 提交
    funcSubmit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          const data = this.form;
          const rLoading = this.openLoading();
          request({
            url: "/ntocc-wms-api/contract",
            method: "post",
            params: data,
          })
            .then((response) => {
              this.$message({ message: response.msg, type: "success" });
              rLoading.close();
              this.$refs.upload.clearFiles();
              this.$emit("fatherAddMethod");
            })
            .then(() => this.$refs["form"].resetFields());
        } else {
          return false;
        }
      });
    },

    // 取消
    funcCancel() {
      this.$emit("fatherCancelMethod", "add");
      this.$refs.upload.clearFiles();
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin: 15px 0 15px 0;
  width: 175px;
  float: right;
}
</style>
